export default {"src":"/_next/static/media/slack.b6ef71a4.svg","height":52,"width":94,"blurWidth":0,"blurHeight":0};